// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bb_d3","conditions__content":"bb_d4","conditions__footer":"bb_d5"};